import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'

type Props = {
	id: string
	label: string
	required: boolean
	formStyle: string
	colSpan?: string
	register: UseFormRegister<any>
	errors: FieldErrors
	className?: string
}

export default function CurrentDateInput({
	id,
	label,
	required,
	formStyle,
	colSpan = '1',
	register,
	className,
}: Readonly<Props>) {
	const fieldName = sanitizeFieldName(label)

	// Get current date in US format (MM/DD/YYYY) with UTC
	const getCurrentDate = () => {
		const today = new Date()
		// Create UTC date to avoid timezone issues
		const utcDate = new Date(
			Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
		)

		return new Intl.DateTimeFormat('en-US', {
			month: '2-digit',
			day: '2-digit',
			year: 'numeric',
			timeZone: 'UTC',
		}).format(utcDate)
	}

	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan],
				className
			)}
		>
			<div className={clsx('form-element-container', formStyle === 'line' && 'line-style')}>
				<input
					id={id}
					type="text"
					className="input"
					readOnly
					defaultValue={getCurrentDate()}
					{...register(fieldName)}
				/>
			</div>
			<label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</label>
		</div>
	)
}
